import { Record } from 'immutable'

export class InvoiceItemType extends Record({
    id: undefined,
    code: undefined,
    name: undefined,
    tax_rate_type_id: undefined,
}) {}
